import { QuoteEmail } from "./email.model";
import { Client } from "../../client/client.model";
import { BaseUser } from "../../user/base-user.model";
import { Insurance } from "./insurance.model";
import { BaseLclQuote } from "./quote-base-lcl.model";
import { QuoteLocation } from "./quote-location.model";
import { Package } from "../quote-form/quote-package/package.model";
import { locationKind } from "app/location/location-kind.const";

export class FtlQuote extends BaseLclQuote {
  constructor(
    protected id: number,
    protected displayId: string,
    protected groupId: number,
    protected ref: string,
    protected sender: BaseUser,
    protected createdBy: BaseUser,
    protected status: string,
    protected quoteType: string,
    protected direction: string,
    protected incotermType: string,
    protected clients: Client[],
    protected hasOrigin: boolean,
    protected hasDestination: boolean,
    protected originLocations: QuoteLocation[],
    protected destinationLocations: QuoteLocation[],
    protected createdAt: Date,
    protected updatedAt: Date,
    protected updatedBy: BaseUser,
    protected openedAt: Date,
    protected validFrom: Date,
    protected validTo: Date,
    protected weight: number,
    protected measurement: number,
    protected pieces: number,
    protected comment: string,
    protected showRateSurcharges = false,
    protected showNoMarginSurcharges = false,
    protected showCarrier = false,
    protected showInland = false,
    protected showTotal = false,
    protected totalCurrency = null,
    protected showInvoiceInfo = false,
    protected invoiceCurrency = false,
    protected groupRoutes = false,
    protected email: QuoteEmail,
    protected internalComment: string,
    protected customTerms: string,
    protected fileName: string,
    protected fileNameInternal: string,
    protected averageMargin: number,
    protected averageMarginEuro: number,
    protected averageMarginPercent: number,
    protected inquiry: string,
    protected source: string,
    protected insurance: Insurance | null,
    protected reasonOfDecline: string,
    protected input: string | null,
    protected offerLanguage: string | null,
    protected packages: Package[],
    protected chargeableWeight: number,
    protected ldm: number,
  ) {
    super(
      id,
      displayId,
      groupId,
      ref,
      sender,
      createdBy,
      status,
      quoteType,
      direction,
      incotermType,
      clients,
      hasOrigin,
      hasDestination,
      originLocations,
      destinationLocations,
      null,
      createdAt,
      updatedAt,
      updatedBy,
      openedAt,
      validFrom,
      validTo,
      weight,
      measurement,
      pieces,
      comment,
      showRateSurcharges,
      showCarrier,
      showInland,
      showTotal,
      totalCurrency,
      showInvoiceInfo,
      invoiceCurrency,
      groupRoutes,
      email,
      internalComment,
      customTerms,
      fileName,
      fileNameInternal,
      averageMargin,
      averageMarginPercent,
      inquiry,
      source,
      insurance,
      reasonOfDecline,
      input,
      offerLanguage,
      false,
      false,
      null,
      null,
      packages,
      chargeableWeight,
      ldm,
    );
  }

  public getDirection(): string {
    return this.direction;
  }

  public setDirection(m: string) {
    this.direction = m;
  }

  public getKind(): string {
    return locationKind.roadTerminal;
  }

  public requiresResolvedLocation(): boolean {
    return false;
  }

  public isValid(): boolean {
    return super.isValid();
  }
}
